import { render } from "./SlideEntry.vue?vue&type=template&id=32b81b89"
import script from "./SlideEntry.vue?vue&type=script&lang=js"
export * from "./SlideEntry.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__